/** localStorage draft for /whynotld. */
export const WHY_NOT_LD_STORAGE_KEY = 'ldsurvey:whyNotLd';

export type WhyNotLdAnswers = {
  answer: string;
};

export function readWhyNotLdAnswers(): WhyNotLdAnswers {
  try {
    const raw = localStorage.getItem(WHY_NOT_LD_STORAGE_KEY);
    if (!raw) return { answer: '' };
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return { answer: '' };
    const o = parsed as Record<string, unknown>;
    return { answer: typeof o.answer === 'string' ? o.answer : '' };
  } catch {
    return { answer: '' };
  }
}

export function writeWhyNotLdAnswers(data: WhyNotLdAnswers): void {
  try {
    localStorage.setItem(WHY_NOT_LD_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearWhyNotLdAnswers(): void {
  try {
    localStorage.removeItem(WHY_NOT_LD_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isWhyNotLdComplete(): boolean {
  return readWhyNotLdAnswers().answer.trim().length > 0;
}
